import { useHistory } from "react-router";
import { isEmpty } from "lodash";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../../../actions/user";
import { errorMessage, successMessage } from "../../../../utils/messages";
import { usersAddNewBankCard } from "../../../../services/userServices";

//Styles and Icons
import styles from "./CardsAccountInfo.module.scss";
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";

export default function CardsAccountInfo() {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.fullUserInfo.data_profile);
  useEffect(() => {
    if (!userInfo) dispatch(userProfile());
  }, []);
  const history = useHistory();
  const [addCardDetails, setAddCardDetails] = useState({
    cardNumber: "",
    ibanNumber: "",
    error: "",
    deActive: false,
  });
  const handleAddUserCard = async (e) => {
    e.preventDefault();
    let pattern = /^(?:IR)(?=.{24}$)[0-9]*$/;

    if (addCardDetails.cardNumber.trim().length < 15)
      return setAddCardDetails({
        ...addCardDetails,
        error: "شماره کارت وارد شده صحیح نمی باشد",
      });
    if (!pattern.test(addCardDetails.ibanNumber))
      return setAddCardDetails({
        ...addCardDetails,
        error:
          "شماره شبا به درستی وارد نشده, مثال صحیح: IR270610000001001000652764",
      });
    try {
      setAddCardDetails({ ...addCardDetails, deActive: true });
      const { cardNumber, ibanNumber } = addCardDetails;
      const cardInfo = { cardNumber, ibanNumber };
      const { data } = await usersAddNewBankCard(cardInfo);
      if (data.error) {
        return errorMessage(data.message);
      }
      setAddCardDetails({ ...addCardDetails, cardNumber: "", ibanNumber: "" });
      dispatch(userProfile());
      successMessage(data.message);
    } catch (ex) {
      errorMessage("مشکلی پیش امده دوباره تلاش کنید");
    } finally {
      setAddCardDetails({ ...addCardDetails, deActive: false });
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.back_btn}>
        <img
          src={ArrowBackIcon}
          alt="BACK"
          width={15}
          height={15}
          onClick={() => history.goBack()}
          className="convertPicToWhite"
        />
      </div>
      <div className={`font_color_white ${styles.title_of_page}`}>
        کارت های بانکی
      </div>
      <div className={styles.table_of_carts}>
        <div className={styles.header_table}>
          <div>کارت های بانکی</div>
          <div>وضعیت</div>
        </div>
        <div className={styles.user_carts}>
          {/*For EACH HERE*/}
          {!isEmpty(userInfo?.cards) ? (
            <>
              {userInfo?.cards?.map((card) => (
                <div className={styles.user_card} key={card.cardNumber}>
                  <div className={styles.cart_info}>
                    <div>{card.cardNumber.match(/.{1,4}/g).join("-")}</div>
                    <div>{card.ibanNumber}</div>
                  </div>
                  <div className={styles.cart_status}>
                    <div>
                      {card.status === "APPROVED"
                        ? "تایید شده"
                        : card.status === "REJECTED"
                        ? "رد شده"
                        : "درانتظار بررسی"}
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className={styles.user_card}>
              <div className={styles.cart_info}>
                <div></div>
                <div style={{ marginTop: "20px" }}>کارتی ثبت نشده</div>
              </div>
              <div className={styles.cart_status}>
                <div></div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.inputs_container}>
        <form onSubmit={(e) => handleAddUserCard(e)}>
          <input
            className="changeBackgroundToWhite changeFontColorToBlack"
            type="number"
            placeholder="شماره کارت*"
            onChange={(e) =>
              setAddCardDetails({
                ...addCardDetails,
                cardNumber: e.target.value,
              })
            }
            value={addCardDetails?.cardNumber}
          />
          <input
            className="changeBackgroundToWhite changeFontColorToBlack"
            type="text"
            placeholder="شماره شبا*"
            onChange={(e) =>
              setAddCardDetails({
                ...addCardDetails,
                ibanNumber: e.target.value,
              })
            }
            value={addCardDetails?.ibanNumber}
          />
          <div className={styles.errors_place}>{addCardDetails.error}</div>
          <div className={styles.btn_container}>
            <button type="submit" disabled={addCardDetails.deActive}>
              ثبت
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
